import { LoadablePaint } from '@confluence/loadable';

export const CarouselLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Carousel" */ './Carousel')).Carousel,
});
